module.exports = __webpack_public_path__ + "img/theres-the-buoy.e061ef22.jpg";